import {useCallback, useRef} from 'react';

function useEvent<Params extends Array<unknown>, ReturnType>(
  callback: (...params: Params) => ReturnType,
): (...params: Params) => ReturnType {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useCallback((...params: Params) => {
    return callbackRef.current?.(...params);
  }, []);
}

export default useEvent;
